import { useDispatch } from 'react-redux';
import { Grid, Button, Dialog, Box, Typography } from '@mui/material';
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';

import {
  useGetAuthenticationQuery,
  useDeleteCollectionMutation,
} from '../../services/ADapi';
import { notificationSuccess } from '../../store/notificationReducer';

import './Collections.scss';

const RemoveCollection = ({ collectionId, collectionName, onClose }) => {
  const dispatch = useDispatch();
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const [deleteCollection] = useDeleteCollectionMutation();

  const deleteCollectionHandler = async () => {
    try {
      await deleteCollection({
        user_id,
        collectionId,
      }).unwrap();
      dispatch(
        notificationSuccess({
          isNotification: true,
          type: 'success',
          action: 'remove_domain',
          message: `${collectionName} was successfully deleted`,
        })
      );
    } catch (error) {
      console.error(error);
      notificationSuccess({
        isNotification: true,
        type: 'error',
        message: 'An error occured',
      });
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '48px',
          height: '48px',
          margin: 'auto',
          borderRadius: '50%',
          backgroundColor: 'warning.main',
        }}
      >
        <GppBadOutlinedIcon
          fontSize="medium"
          sx={{ color: 'primary.contrastText' }}
        />
      </Box>
      <Typography variant="h2" sx={{ pt: '12px', pb: 3 }}>
        Are you sure you want to delete <br /> the {collectionName}?
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Button
            variant="error"
            onClick={deleteCollectionHandler}
            size="small"
            sx={{
              width: '100%',
              backgroundColor: 'error.main',
              color: '#fff',
              border: '1px solid',
              borderColor: `error.main`,
              '&:hover': { backgroundColor: 'error.main' },
            }}
          >
            Delete
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Button
            variant="outlined"
            onClick={onClose}
            size="small"
            sx={{
              width: '100%',
            }}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default RemoveCollection;
